import CryptoJS from 'crypto-js';

export const createHmac = (message: string): string => {
    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY || "mySecretKey";
    const hmac = CryptoJS.HmacSHA256(message, SECRET_KEY);
    return hmac.toString(CryptoJS.enc.Hex);
};